<div class="modal-header">{{ params.connection.name }}</div>
<div class="modal-body">
  @if (step == "done") {
    <div class="text-center text-info">
      <div><i class="far fa-ellipsis-h fa-3x"></i></div>
      <div translate>Almost done</div>
      <span class="text-muted" translate>Select a gallery to complete the upload</span>
      <br />
    </div>
  }
  @if (step == "saved") {
    <div class="text-center text-success">
      <div><i class="far fa-check fa-3x"></i></div>
      <div translate>Click Upload complete</div>
      <br />
    </div>
  }
  @if (step == "uploading") {
    <div class="list-group mb-4">
      @if (currentAsset) {
        <div class="list-group-item d-flex align-items-center" [title]="currentAsset.displayName">
          <asset-thumbnail class="sm me-3" [asset]="$any(currentAsset)" />
          <div class="w-100">
            <div class="no-wrap">{{ currentAsset.displayName }}</div>
            <div class="no-wrap">
              <smart-progress
                [max]="params.assets.length"
                [value]="uploadedCount + 1"
                [text]="
                  'Uploading {count} of {total}'
                    | translate: { count: uploadedCount + 1, total: params.assets.length }
                "
              />
            </div>
          </div>
        </div>
      }
      <a
        class="list-group-item list-group-item-action d-flex align-items-center"
        (click)="notifyOnCompletion = !notifyOnCompletion"
        [class.active]="notifyOnCompletion"
      >
        @if (!notifyOnCompletion) {
          <i class="far fa-2x fa-fw fa-bell"></i>
        }
        @if (notifyOnCompletion) {
          <i class="far fa-2x fa-fw fa-check text-info"></i>
        }
        <div class="ms-2">
          <strong translate>Notify me when the upload is complete</strong>
          <div translate>Sends a notification according to your notification settings.</div>
        </div>
      </a>
    </div>
  }
  @if (params.connection) {
    <div>
      @if (!gallery && galleries) {
        <div>
          <h3 translate>Select or create a gallery</h3>
          @if (galleriesLoading) {
            <spinner />
          }
          @if (galleries.length > 0) {
            <filterbox [(ngModel)]="galleriesFilter" />
          }
          @if (!galleriesLoading) {
            <div class="list-group">
              <a class="list-group-item list-group-item-action" (click)="selectGallery(null)">
                <i class="far fa-fw fa-plus"></i>
                <span translate>Create a new gallery</span>
              </a>
              @for (
                gallery of galleries
                  | naturalOrderBy: "name"
                  | filterBy: ["name"] : galleriesFilter;
                track gallery
              ) {
                <a class="list-group-item list-group-item-action" (click)="selectGallery(gallery)">
                  <i class="far fa-fw fa-folder"></i>
                  <span>{{ gallery.name }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
      @if (gallery) {
        <div>
          <br />
          <h3 translate>Selected gallery</h3>
          <div class="form-group">
            <div class="list-group-item combi double">
              <div class="list-group-main d-flex align-items-center" [title]="gallery.name">
                <i class="far fa-2x fa-fw fa-folder-open me-3"></i>
                <div class="no-wrap">
                  <strong translate>Gallery</strong>
                  <div class="no-wrap">{{ gallery.name }}</div>
                </div>
              </div>
              <a
                class="btn btn-link"
                [href]="gallery.presignedLoginUrl"
                target="_blank"
                [title]="'View gallery' | translate"
              >
                <i class="far fa-external-link">
                  <span class="visually-hidden" translate>View gallery</span>
                </i>
              </a>
            </div>
          </div>
          <br />
          <h3 translate>Links</h3>
          @for (link of links; track link) {
            @if ($count > 0) {
              <div class="mb-4">
                <div class="form-control-static no-wrap">
                  <i class="icon-link"></i>
                  &nbsp;
                  @if (!link.elementsUser?.email) {
                    <span>Link</span>
                  }
                  @if (link.elementsUser?.email) {
                    <span>{{ link.elementsUser!.email }}</span>
                  }
                  @if (link.viewsLeft == null) {
                    <span class="text-muted">
                      &nbsp; - &nbsp;
                      <span translate>Unlimited views</span>
                    </span>
                  }
                  @if (link.viewsLeft != null) {
                    <span class="text-muted">
                      &nbsp; - &nbsp;
                      <span>
                        {{ "{ count } views left" | translate: { count: link.viewsLeft } }}
                      </span>
                    </span>
                  }
                </div>
                <div class="d-flex align-items-center">
                  <input
                    class="form-control"
                    type="text"
                    readonly
                    [value]="params.connection.url + '/link/' + link.secretKey"
                    autoselect
                    [srLabel]="'link' | translate"
                  />
                  <button class="btn btn-secondary" (click)="deleteLink(link)">
                    <i class="far fa-trash-alt">
                      <span class="visually-hidden" translate>Delete</span>
                    </i>
                  </button>
                </div>
              </div>
            }
          }
          <button class="btn btn-secondary" (click)="createLink()">
            <i class="far fa-link"></i>
            <span translate>Create a link</span>
          </button>
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  @if (step == "uploading") {
    <button
      class="btn btn-outline-primary"
      [clickBlocking]="background"
      [disabled]="!gallery?.id"
      translate
    >
      Continue in background
    </button>
  }
  @if (step != "saved") {
    <button class="btn btn-outline-secondary" (click)="abort()" translate>Cancel</button>
  }
  @if (step == "saved") {
    <button class="btn btn-outline-secondary" (click)="close()" translate>Close</button>
  }
</div>
